// extracted by mini-css-extract-plugin
export default {"reset":"reset__a2I85r","checkIcon":"checkIcon__XZ3oH_","closeIcon":"closeIcon__rj9kLI"};